// extracted by mini-css-extract-plugin
export default {"controls":"MissingInvoicesTableFilters_controls__uZ2lu"};